import domEnums from 'app/dom_mutators/enums';

export default function isCustomButtonPresent() {
  return !!document.getElementById(domEnums.CUSTOM_BUTTON_ID);
}
